import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tip" }

import { ref } from 'vue'
import { ElDialog, ElMessage } from 'element-plus'
import { resourcerFileUpload } from '@/api/design/resource'
import { useSdkStore } from '@/stores/sdk'


export default /*@__PURE__*/_defineComponent({
  __name: 'fileImport',
  setup(__props) {

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
const dialogVisible = ref(false)
const isDragOver = ref(false)
const fileInput = ref<HTMLInputElement | null>(null)

const onClickUpload = () => fileInput.value?.click()
const onDragOver = () => { isDragOver.value = true }
const onDragLeave = () => { isDragOver.value = false }
const onDrop = async (e: DragEvent) => {
    isDragOver.value = false
    const files = e.dataTransfer?.files
    if (!files || !files.length) return
    if (files.length > 1) ElMessage.warning('仅支持选择一个文件，已取第一个')
    await handleFile(files[0])
}
const onFileChange = async (e: Event) => {
    const input = e.target as HTMLInputElement
    const files = input.files ? Array.from(input.files) : []
    if (!files.length) return
    if (files.length > 1) ElMessage.warning('仅支持选择一个文件')
    await handleFile(files[0])
    input.value = ''
}

const allowed = ['psd', 'psb', 'ai', 'sketch', 'pdf', 'png', 'jpg', 'jpeg', 'webp', 'gif', 'svg']
const handleFile = async (file: File) => {
    const ext = file.name.split('.').pop()?.toLowerCase() || ''
    if (!allowed.includes(ext)) { ElMessage.error('不支持的文件类型'); return }
    dialogVisible.value = false
    desginsdk.designOpt.showLoading(true)
    try {
        let res = await resourcerFileUpload(file)
        if (res.data.code == 200) {


            await desginsdk.designOpt.requireFile(res.data.data.url)
            desginsdk.designOpt.showLoading(false)
        }
        dialogVisible.value = false
    } catch {
        dialogVisible.value = false
        ElMessage.error('上传失败')
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "w-full h-40px flex items-center px-[15px] cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = true))
    }, "导入文件"),
    _createVNode(_unref(ElDialog), {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      title: "导入文件",
      width: "520"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["import-wrap", { dragover: isDragOver.value }]),
          onDragover: _withModifiers(onDragOver, ["prevent"]),
          onDragleave: _withModifiers(onDragLeave, ["prevent"]),
          onDrop: _withModifiers(onDrop, ["prevent"]),
          onClick: onClickUpload
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icons" }, [
            _createElementVNode("div", { class: "icon ps" }, ".PSD"),
            _createElementVNode("div", { class: "icon ai" }, ".png"),
            _createElementVNode("div", { class: "icon sketch" }, ".jpg"),
            _createElementVNode("div", { class: "icon pdf" }, ".jpeg"),
            _createElementVNode("div", { class: "icon img" }, ".svg")
          ], -1)),
          _createElementVNode("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createTextVNode(" 将文件拖到此处，或 ", -1)),
            _createElementVNode("a", {
              class: "upload-link",
              onClick: _withModifiers(onClickUpload, ["stop"])
            }, "点击上传"),
            _createElementVNode("input", {
              ref_key: "fileInput",
              ref: fileInput,
              type: "file",
              class: "hidden-input",
              accept: ".psd,.psb,.png,.jpg,.jpeg,.svg",
              onChange: onFileChange
            }, null, 544)
          ])
        ], 34)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})